module.exports = __webpack_public_path__ + "img/radarBase.93881629.jpg";